import {Component, ChangeDetectionStrategy} from '@angular/core';
import { Version } from '../../version';


@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FooterComponent {
    version: string;

    ngOnInit() {
            this.version = 'version ' + Version.getVersion();
    }
}
